import React, { useEffect, useRef } from 'react';
import { useReducedMotion } from 'framer-motion';

// Faint gold dust particles drifting upward. Canvas overlay, pointer-events none.
const GoldParticles = ({ count = 74, className = '' }) => {
  const canvasRef = useRef(null);
  const reduce = useReducedMotion();

  useEffect(() => {
    if (reduce) return undefined;
    const canvas = canvasRef.current;
    if (!canvas) return undefined;
    const ctx = canvas.getContext('2d');
    let raf; let w; let h;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    const resize = () => {
      w = canvas.offsetWidth; h = canvas.offsetHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();

    const golds = ['231,211,161', '198,161,91', '255,240,205'];
    const parts = Array.from({ length: count }, () => ({
      x: Math.random(), y: Math.random(),
      r: 0.6 + Math.random() * 1.8,
      vy: 0.00016 + Math.random() * 0.00034,
      sway: 6 + Math.random() * 18,
      phase: Math.random() * Math.PI * 2,
      speed: 0.4 + Math.random() * 0.9,
      base: 0.18 + Math.random() * 0.4,
      c: golds[Math.floor(Math.random() * golds.length)],
    }));

    let t = 0;
    const draw = () => {
      t += 0.016;
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        p.y -= p.vy;
        if (p.y < -0.02) { p.y = 1.02; p.x = Math.random(); }
        const x = p.x * w + Math.sin(t * p.speed + p.phase) * p.sway;
        const y = p.y * h;
        const a = p.base * (0.55 + 0.45 * Math.sin(t * p.speed * 1.6 + p.phase));
        ctx.beginPath();
        ctx.arc(x, y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${p.c},${a.toFixed(3)})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    window.addEventListener('resize', resize);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', resize); };
  }, [reduce, count]);

  if (reduce) return null;
  return <canvas ref={canvasRef} aria-hidden="true" data-testid="gold-particles" className={`absolute inset-0 w-full h-full pointer-events-none ${className}`} />;
};

export default GoldParticles;
